export const shippingOptions = [
  {
    id: '2',
    name: 'SHIPMENT_OPTIONS.STANDARD_TITLE',
    description: 'SHIPMENT_OPTIONS.STANDARD_DESC',
  },
  {
    id: '4',
    name: 'SHIPMENT_OPTIONS.EXPRESS_TITLE',
    description: 'SHIPMENT_OPTIONS.EXPRESS_DESC',
  },
];
